/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'people.menu.renotify.flag.description':
    'Es wird allen eine Erinnerung per E-Mail gesendet. Dies kann bis zu einer Minute dauern.',
  'people.menu.renotify.flag.description.confluence': 'Teammitglieder erinnern',
  'people.menu.renotify.flag.title': 'Erinnerungen werden gesendet',
  'people.menu.renotify.flag.title.confluence': 'Einladungs-E-Mail wird erneut gesendet',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} Person hat die Einladung zu {product} nicht angenommen. Sehen Sie sich an, wer fehlt, und senden Sie der Person eine Erinnerung.} other {{userCount,number} Personen haben die Einladung zu {product} nicht angenommen. Sehen Sie sich an, wer fehlt, und senden Sie den Personen eine Erinnerung.}}',
  'people.menu.renotify.menu.description.confluence':
    'Einige Personen haben ihre Confluence-Einladung nicht angenommen. Sehen Sie sich an, wer fehlt, und senden Sie der Person eine Erinnerung.',
  'people.menu.renotify.menu.dismiss': 'Verwerfen',
  'people.menu.renotify.menu.dismiss.confluence': 'Nicht jetzt',
  'people.menu.renotify.menu.remind': 'Teammitglieder erinnern',
  'people.menu.renotify.menu.remind.confluence': 'Teammitglieder erinnern',
  'people.menu.renotify.menu.title': 'Ist das Team vollständig?',
  'people.menu.renotify.modal.copied': 'Link kopiert',
  'people.menu.renotify.modal.copy': 'Einladungslink kopieren',
  'people.menu.renotify.modal.description':
    'Wir können eine Erinnerung an die fehlenden Mitglieder schicken oder Sie können den Einladungslink selbst mit ihnen teilen.',
  'people.menu.renotify.modal.description.confluence':
    'Senden Sie die Einladungs-E-Mail erneut oder kopieren Sie den Einladungslink und teilen Sie ihn.',
  'people.menu.renotify.modal.dismiss': 'Abbrechen',
  'people.menu.renotify.modal.resend': 'Erinnerung senden',
  'people.menu.renotify.modal.resend.confluence': 'Einladung erneut senden',
  'people.menu.renotify.modal.title': 'Fehlende Mitglieder erinnern',
  'people.menu.renotify.modal.title.confluence': 'Fehlende Teammitglieder erinnern',
  'ptc.pm.collaborators.title': 'Ihre Mitarbeiter',
  'ptc.pm.error-heading': 'Fehler',
  'ptc.pm.error-image-alt-text': 'Ein kaputter Roboter und mehrere Personen, die ihn reparieren',
  'ptc.pm.error-text':
    'Wir verfolgen diese Fehler, aber Sie können sich gerne an uns wenden, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} Mitglied} other {{memberCount,number} Mitglieder}}',
  'ptc.pm.people': 'Personen',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Profil anzeigen',
  'ptc.pm.your-teams.title': 'Ihre Teams',
};
